import { LabMDM } from './lab';

export class ResultProcess {
    _id : string;
    version : number;
    lab: LabMDM;
    name  : string;
    mergeGroup : string;
    rawDataRequired : boolean;
    resultFileRequired : boolean;
    reportRequired : boolean;
    containerName : string;
    storageType : string;
    storageKey : string;
    storageDetail : string;
    metaDataFileRequired : boolean;
    active : boolean;
}
export enum StorageType {

  BlobStorage = "BlobStorage",

  SFTP = "SFTP",

}

export enum FileType {

  csv = "csv",

  Excel = "Excel",

  HL7 = "HL7",

  resultReport = "resultReport"

}
